"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ContractHasNoAddressError = void 0;
class ContractHasNoAddressError extends Error {
}
exports.ContractHasNoAddressError = ContractHasNoAddressError;
